import styled from '@emotion/styled'
import { useRouter } from '../../utils/helper'
import Loading from '../../components/common/Loading'
import { mobile } from '../../utils/responsive-helper'
import Headbar from '../../components/common/HeadBar'
import * as paths from '../../constant/path'
import { useSelector } from 'react-redux'
import { RootState } from '../../redux-store'
import color from '../../constant/colors'
import InsuranceForm from './InsuranceForm'
import { InsuranceInfoWithConcentDate, InsuranceInfoWithoutConcentDate } from '../../redux-store/insurance-reducer'
import { useGetInsuranceById } from '../../services/insurance/insurance-query'

const BackgroundHeader = styled.div`
  background-color: ${color.CHOICES_PRIMARY};
  width: calc(100% - 32px);
  height: 266px;
  margin-top: 0px !important;
  position: absolute;

  ${mobile} {
    width: 100%;
  }
`
const Layout = styled.div`
  width: 768px;
  margin: 0 auto;
  z-index: 1;
  > * {
    margin-top: 24px;
  }

  ${mobile} {
    width: 100%;
  }
`

const InsuranceDetail = () => {
  const { query } = useRouter<{ insuranceId: number, claimTypeId: string, isCreateNew: 'true' | 'false' }>()
  const { data: insuranceItem, isLoading } = useGetInsuranceById({ claimId: query.insuranceId })
  const InsuranceFormValue = useSelector((state: RootState) => state.insurance.InsuranceInfo) as InsuranceInfoWithoutConcentDate & InsuranceInfoWithConcentDate

  return (
    <Loading loading={false}>
      <BackgroundHeader />
      <Layout>
        <Headbar title={insuranceItem?.name || ''} backWard={paths.insurance()} />
        {/* <EClaimInfo eClaimItem={eClaimItem} /> */}

        {/*   <EClaimDocument /> */}

        <InsuranceForm insuranceItem={insuranceItem} insuranceFormValue={InsuranceFormValue} insuranceId={query.insuranceId} allpayStatus={false} isCreateNew={query.isCreateNew} />
      </Layout>
    </Loading>
  )
}

export default InsuranceDetail